/**
 * Stats mensuales takeoff derivados del API (remaining_units / people_needed).
 * El cálculo vive en BoqRoot::computeTakeoffMonthlyDerivedStats (PHP).
 */

export function normalizeTakeoffMonthlyMap(raw) {
  if (raw == null || raw === '') {
    return {}
  }
  if (typeof raw === 'string') {
    try {
      const parsed = JSON.parse(raw)
      return typeof parsed === 'object' && parsed !== null ? parsed : {}
    } catch (error) {
      return {}
    }
  }
  if (typeof raw === 'object') {
    return { ...raw }
  }
  return {}
}

export function applyTakeoffHhPctFromDistributions(stats, distributions) {
  const list = Array.isArray(distributions) ? distributions : []
  list.forEach((item) => {
    const yearMonth = item && item.year_month
    if (!yearMonth) {
      return
    }
    const key = `hh_pct_month_${yearMonth}`
    if (Object.prototype.hasOwnProperty.call(stats, key)) {
      stats[key] = Number(item.percent) || 0
    }
  })
}

export function sigmaPercentFromHhPctStats(stats, hhPctKeys) {
  return hhPctKeys.reduce((sum, key) => {
    const value = Number(stats[key])
    return sum + (Number.isFinite(value) ? value : 0)
  }, 0)
}

export function applyTakeoffMonthlyDerivedFromApi(stats, raw, mappingStatsKeys) {
  const unitsMap = normalizeTakeoffMonthlyMap(raw && raw.remaining_units_per_month)
  const peopleMap = normalizeTakeoffMonthlyMap(raw && raw.people_needed_per_month)
  const keys = Array.isArray(mappingStatsKeys) ? mappingStatsKeys : []

  keys.forEach((key) => {
    const keyStr = String(key)
    if (keyStr.startsWith('units_month_')) {
      const yearMonth = keyStr.replace('units_month_', '')
      stats[key] = unitsMap[yearMonth] != null ? Number(unitsMap[yearMonth]) : 0
    }
    if (keyStr.startsWith('people_month_')) {
      const yearMonth = keyStr.replace('people_month_', '')
      stats[key] = peopleMap[yearMonth] != null ? Number(peopleMap[yearMonth]) : 0
    }
  })
}

export function takeoffMonthlyDerivedSnapshot(raw) {
  return {
    remaining_units_per_month: raw && raw.remaining_units_per_month != null
      ? normalizeTakeoffMonthlyMap(raw.remaining_units_per_month)
      : null,
    people_needed_per_month: raw && raw.people_needed_per_month != null
      ? normalizeTakeoffMonthlyMap(raw.people_needed_per_month)
      : null,
  }
}

export function applyTakeoffMonthlyStatsFromApi(stats, raw, options = {}) {
  const {
    distributions = raw && raw.monthly_distributions,
    mappingStatsKeys = [],
    hhPctKeys = mappingStatsKeys.filter((key) => String(key).startsWith('hh_pct_month_')),
  } = options

  applyTakeoffHhPctFromDistributions(stats, distributions)
  stats.sigma_percent = sigmaPercentFromHhPctStats(stats, hhPctKeys)
  applyTakeoffMonthlyDerivedFromApi(stats, raw, mappingStatsKeys)
}
